package com.klantenstop.web.components.dialogs

import androidx.compose.runtime.Composable
import com.klantenstop.web.components.Dialog
import com.klantenstop.web.navigation.Navigation
import com.materialkobweb.components.widgets.DsMaterialSymbols
import com.materialkobweb.components.widgets.FilledButton
import com.materialkobweb.components.widgets.IconButton
import com.materialkobweb.components.widgets.OutlinedButton
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.marginBlock
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.ButtonSize
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.attributes.ButtonType
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Text

@Composable
fun LoginRequiredDialog(
    onHideDialog: () -> Unit
) {
    val ctx = rememberPageContext()
    Dialog(
        onHideDialog = onHideDialog
    ) {
        Row(
            modifier = Modifier.fillMaxWidth(),
            horizontalArrangement = Arrangement.SpaceBetween
        ) {
            H2(
                attrs = Modifier.marginBlock(0.px).toAttrs()
            ) {
                Text("Inloggen vereist")
            }

            IconButton(
                modifier = Modifier,
                size = ButtonSize.SM,
                type = ButtonType.Button,
                enabled = true,
                onClick = onHideDialog,
                content = {
                    DsMaterialSymbols(
                        icon = "close",
                        modifier = Modifier.fontSize(20.px)
                    )
                }
            )
        }

        SpanText(
            modifier = Modifier
                .margin(top = 24.px)
                .fontSize(16.px)
                .lineHeight(24.px),
            text = "Je moet ingelogd zijn om deze actie uit te voeren. Log in of maak een account aan om door te gaan."
        )

        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top = 36.px),
            horizontalArrangement = Arrangement.spacedBy(12.px)
        ) {
            OutlinedButton(
                onClick = {
                    onHideDialog()
                }
            ) {
                Text("Annuleren")
            }

            FilledButton(
                onClick = {
                    onHideDialog()
                    ctx.router.navigateTo(
                        Navigation.Screen.Login(
                            returnTo = ctx.route.pathQueryAndFragment
                        ).route
                    )
                }
            ) {
                Text("Inloggen")
            }
        }
    }
}
